import clsx from 'clsx'
import {useIntl} from 'react-intl'

type InputClickEditProps = {
  disabled?: boolean
  value?: any
  className?: string
  placeholder?: string
  onClick?: () => void
  isValid?: boolean
  isInvalid?: boolean
}
export const InputClickEdit = ({
  disabled,
  value,
  className,
  placeholder,
  onClick,
  isValid,
  isInvalid,
}: InputClickEditProps) => {
  const intl = useIntl()

  const handleOnClick = () => {
    if (disabled) return
    onClick?.()
  }
  return (
    <div className='position-relative'>
      <div
        className={clsx(
          'form-control input-custom__input text-truncate pr-5',
          {
            'border border-1 border-primary': isValid,
            'border border-1 border-danger': isInvalid,
          },
          className
        )}
        style={{paddingRight: '50px'}}
      >
        {value || placeholder}
      </div>
      <div
        className={clsx(
          'position-absolute top-0 right-4 h-100 d-flex text-decoration-underline fs-6 pt-3',
          {
            'text-gray-500 cursor-not-allowed': disabled,
            'text-primary cursor-pointer': !disabled,
          }
        )}
        onClick={handleOnClick}
      >
        {intl.formatMessage({id: value ? 'EDIT' : 'ADD'})}
      </div>
    </div>
  )
}
